import { Role, RouteInfo } from '@app/shared/common';

/**
 * @description
 * Here you can define all menu items from main sidebar menu
 * @see RouteInfo interface for all posible item configurations
 */
export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'Dashboard',
    icon: 'pi pi-chart-line',
    progress: true,
    name: 'dashboard',
  },
  // USERS
  {
    title: 'Users',
    type: 'title',
    name: 'users',
  },
  {
    path: '/retailers',
    title: 'Retailers',
    icon: 'pi pi-building',
    name: 'retailers',
  },
  {
    path: '/sale-points',
    title: 'Point of sales',
    icon: 'pi pi-briefcase',
    name: 'sale-points',
  },
  {
    path: '/users',
    title: 'Users',
    icon: 'pi pi-users',
    role: [Role.SUPERADMIN],
    name: 'users',
  },
  // {
  //   path: '/users/requests',
  //   title: 'Requests',
  //   icon: 'pi pi-user-plus',
  //   role: [Role.SUPERADMIN],
  // },
  {
    path: '/administration',
    title: 'Administration',
    icon: 'pi pi-user-edit',
  },
  {
    title: 'Rules',
    type: 'title',
    name: 'terms-and-conditions',
  },
  {
    path: '/terms-and-conditions',
    title: 'Terms of use',
    icon: 'pi pi-align-center',
    name: 'terms-and-conditions',
  },
  // FAQ
  {
    title: 'FAQ',
    type: 'title',
    name: 'faqs',
  },
  {
    path: '/faqs',
    title: 'FAQ',
    icon: 'pi pi-comments',
    name: 'faqs',
  },
  // ANNOUNCEMENTS
  {
    title: 'Announcements',
    type: 'title',
    name: 'news',
  },
  {
    path: '/news',
    title: 'News',
    icon: 'pi pi-envelope',
    name: 'news',
  },
  {
    path: '/promotions',
    title: 'Promotions',
    icon: 'pi pi-flag',
    name: 'promotions',
  },
  // ARTICLES
  {
    title: 'Articles',
    type: 'title',
    role: [Role.SUPERADMIN],
    name: 'product-categories',
  },
  {
    path: '/products/group',
    title: 'Product groups',
    icon: 'pi pi-sitemap',
    role: [Role.SUPERADMIN],
    name: 'product-categories',
  },
  {
    path: '/products',
    title: 'Products ',
    icon: 'pi pi-sitemap',
    role: [Role.SUPERADMIN],
    name: 'products',
  },
  // {
  //   path: '/products/sales-requests',
  //   title: 'Sales requests',
  //   icon: 'pi pi-chart-line',
  //   role: [Role.SUPERADMIN],
  // },
  // {
  //   path: '/products/sales-requests-deleted',
  //   title: 'Deleted requests',
  //   icon: 'pi pi-trash',
  //   role: [Role.SUPERADMIN],
  // },
  // {
  //   path: '/products/sales',
  //   title: 'Sales applications',
  //   icon: 'pi pi-file',
  //   role: [Role.SUPERADMIN],
  // },
  // {
  //   path: '/products/sales-queue',
  //   title: 'Applications pending',
  //   icon: 'pi pi-file-import',
  //   role: [Role.SUPERADMIN],
  // },
  // {
  //   path: '/products/sales-from-reports',
  //   title: 'Applications from the report',
  //   icon: 'pi pi-file-edit',
  //   role: [Role.SUPERADMIN],
  // },
  // {
  //   path: '/products/sales-from-reports-deleted',
  //   title: 'Deleted applications',
  //   icon: 'pi pi-trash',
  //   role: [Role.SUPERADMIN],
  // },
  // BANNERS
  {
    title: 'Banners',
    type: 'title',
    name: 'banners',
  },
  {
    path: '/banners',
    title: 'Banners',
    icon: 'pi pi-clone',
    name: 'banners',
  },
  // VOUCHERS
  {
    title: 'Vouchers',
    type: 'title',
    name: 'vouchers',
  },
  {
    path: '/vendors',
    title: 'Vendors',
    icon: 'pi pi-users',
    name: 'vendors',
  },
  {
    path: '/vouchers',
    title: 'Vouchers',
    icon: 'pi pi-file',
    name: 'vouchers',
  },
  {
    path: '/ordered-vouchers',
    title: 'Voucher requests',
    icon: 'pi pi-file-edit',
    name: 'ordered-vouchers',
  },
  // TRAININGS
  {
    title: 'Trainings',
    type: 'title',
    name: 'training-programs',
  },
  {
    path: '/trainings/category',
    title: 'Categories',
    icon: 'pi pi-sitemap',
    name: 'training-program-categories',
  },
  {
    path: '/trainings',
    title: 'Trainings',
    icon: 'pi pi-wrench',
    name: 'training-programs',
  },
  {
    title: 'Notifications',
    type: 'title',
    name: 'sms-notifications',
  },
  {
    path: '/notifications/translate',
    title: 'Translate',
    icon: 'pi pi-language',
    progress: true,
    name: 'sms-notifications',
  },
  {
    path: '/notifications/sms',
    title: 'SMS',
    icon: 'pi pi-mobile',
    progress: true,
    name: 'sms-notifications',
  },
  {
    path: '/notifications/push',
    title: 'PUSH',
    icon: 'pi pi-angle-double-down',
    progress: true,
    name: 'push-notifications',
  },
  {
    title: 'Logs',
    type: 'title',
    name: 'logs',
  },
  {
    path: '/logs',
    title: 'All logs',
    icon: 'pi pi-list',
    progress: true,
    name: 'logs',
  },
  {
    title: 'Superadmin',
    type: 'title',
    name: 'superadmin',
  },
  {
    path: '/companies',
    title: 'Licenses',
    icon: 'pi pi-briefcase',
    name: 'companies',
  },
  {
    title: 'Resolution center',
    type: 'title',
    name: 'logs',
  },
  {
    path: '/resolution-center',
    title: 'Resolution center',
    icon: 'pi pi-list',
    progress: true,
    name: 'logs',
  },
];
